import './styles.scss'

import { useTranslation } from 'react-i18next'
import { Col, Divider, Row } from 'antd'
import Skeleton from 'react-loading-skeleton'

import { useAppSelector } from '@/store/hook'
import {
  selectCompanyName,
  selectHasSessionBasedShoppingCart,
  selectIsFetchingUserDetails,
  selectUserFirstName,
  selectUserLastName,
  selectUserSalutationLowerCase,
} from '@/store/selectors/userSelector'
import useAdobeAnalysis from '@/hooks/useAdobeAnalysis'
import useCalculateScrollbarWidth from '@/hooks/useCalculateScrollbarWidth'
import useDocumentTitle from '@/hooks/useDocumentTitle'
import PermissionWrapper from '@/HOCs/permissionWrapper'
import { PAGE_TYPES, TRACK_DATA } from '@/libs/constants/adobeAnalytics'
import { MODULE_MACHINE_RIGHTS, MODULE_SHOP_NAVIGATION_RIGHTS } from '@/libs/constants/modulerights'

import MyMachines from './MyMachines'
import OverviewGuide from './OverviewGuide'
import ShopByCategories from './ShopByCategories'
import SpecialsForYou from './SpecialsForYou'

const Greeting = () => {
  const { t } = useTranslation()
  const isFetchingUserDetails = useAppSelector(selectIsFetchingUserDetails)
  const firstName = useAppSelector(selectUserFirstName)
  const lastName = useAppSelector(selectUserLastName)
  const lowerCaseSalutation = useAppSelector(selectUserSalutationLowerCase)
  const title = lowerCaseSalutation && lowerCaseSalutation !== 'other' && lowerCaseSalutation !== 'none'
    ? t(`form.label.${lowerCaseSalutation}`, { defaultValue: '' })
    : ''
  const isTechnicalUser = useAppSelector(selectHasSessionBasedShoppingCart)
  const companyName = useAppSelector(selectCompanyName)

  const nameToDisplay = isTechnicalUser
    ? t('myWorkspace.greeting.titleAndName', {
      title: '',
      firstName: companyName,
      lastName: '',
    })
    : t('myWorkspace.greeting.titleAndName', { title, firstName, lastName })

  if (isFetchingUserDetails) {
    return <Skeleton height={33} width={400} />
  }

  return <span>{t('myWorkspace.greeting.salutation', { name: nameToDisplay })}</span>
}

const MyWorkspace = () => {
  useCalculateScrollbarWidth()
  useDocumentTitle('topHeader')
  useAdobeAnalysis(TRACK_DATA.HOME, {
    pageName: 'home',
    pageId: '1',
    pageType: PAGE_TYPES.STANDARD,
  })

  return (
    <div className="my-workspace__wrapper">
      <div className="my-workspace__welcome-banner lg:top-41">
        <Greeting />
      </div>
      <div className="lg:h-8" />

      <div className="my-workspace__my-machines__wrapper full-width-page-component__wrapper">
        <div className="my-workspace__my-machines__wrapper__inner">
          <PermissionWrapper permission={MODULE_SHOP_NAVIGATION_RIGHTS.USE_PRODUCT_NAVIGATION}>
            <ShopByCategories />
          </PermissionWrapper>
          <Divider style={{ marginTop: 0 }} />
          <OverviewGuide />
        </div>
      </div>

      <PermissionWrapper
        permission={MODULE_SHOP_NAVIGATION_RIGHTS.VIEW_PROMOTION}
      >
        <div className="my-workspace__specials-for-you-section">
          <SpecialsForYou />
        </div>
      </PermissionWrapper>

      <PermissionWrapper permission={MODULE_MACHINE_RIGHTS.VIEW_MACHINE_LIST}>
        <Row gutter={24}>
          <Col span={24}>
            <div className="my-workspace__my-machines__container">
              <MyMachines />
            </div>
          </Col>
        </Row>
      </PermissionWrapper>
    </div>
  )
}

export default MyWorkspace
